var Theme = Theme || {};

Theme.SearchWithinIssue = (function ($) {

    return {
        init: _init
    };

    function _init() {
        bindSearch();
    }

    function bindSearch() {
        $('.js-issue-search').on('keypress', function (e) {
            if (e.key === 'Enter') {
                _executeSearch($(this));
            }
        });

        $('.js-issue-cat-search').on('click', function () {
            _executeSearch($(this).prev('input'));
        });
    }

    function _executeSearch(inputElement) {
        let issue = inputElement.data('issue');
        let volume = inputElement.data('volume');
        let query = inputElement.val();
        _issueSearch(issue, volume, query);
    }

    function _issueSearch(issue, volume, query) {
        let baseSearchUrl = '/search-results?page=1&q={searchQuery}';
        let quickSearchUrl = $('.hfQuickSearchUrl').val();
        if (quickSearchUrl) {
            baseSearchUrl = quickSearchUrl;
        }
        let searchUrl = '';
        if (baseSearchUrl) {
            searchUrl = baseSearchUrl.replace('{searchQuery}', query);
            searchUrl = `${searchUrl}&fl_IssueNo=${issue}&fl_Volume=${volume}`;
            window.location = searchUrl;
        }
    }

})(jQuery);